import React from 'react';
import PropTypes from 'prop-types';
import { ModelYear } from '@sm360/widget-commons-vehicle';

const colourItem = ({ colour, onClick, onMouseEnter, onMouseLeave, colourImageServerDomain }) => {
    let rendered = null;
    if (colour.enabled) {
        rendered = (
            <li
                className={`style-color__button ${colour.selected ? ' selected' : ''} ${
                    !colour.enabled ? ' disable' : ''
                }`}
                key={colour.colourCode}
                onMouseEnter={onMouseEnter}
                onMouseLeave={onMouseLeave}
            >
                <span
                    className="color-cta"
                    role="button"
                    tabIndex={0}
                    onClick={() => colour.enabled && onClick(colour)}
                >
                    <img
                        alt={colour.colourDescription}
                        title={colour.colourDescription}
                        src={colourImageServerDomain + colour.colourTile}
                        className={!colour.enabled && 'is-disabled'}
                    />

                    {!colour.enabled && <icon className="icon-do-not-disturb" />}
                </span>
            </li>
        );
    }
    return rendered;
};

colourItem.propTypes = {
    colour: PropTypes.instanceOf(ModelYear.ColourModel).isRequired,
    onClick: PropTypes.func.isRequired,
    onMouseEnter: PropTypes.func.isRequired,
    onMouseLeave: PropTypes.func.isRequired,
    colourImageServerDomain: PropTypes.string.isRequired,
};

colourItem.displayName = 'colourItem';

export default colourItem;
